export default {
    server_id:"Server ID",
    video_url:"Video URL",
    actions:"Actions",
    no:"No."
};
